import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { nullFunc } from '../utils/helpers';
import ThrottledButton from './ThrottledButton';
import { getIsValidatingAppointment } from '../reservation/selectors';

const ApplePay = ({ hasApplePay, className, processing, onClick, isValidatingAppointment }) => {
  if (!hasApplePay) return null;

  return (
    <ThrottledButton
      type="button"
      className={classnames('c-btn c-btn--apple-pay', className)}
      onClick={onClick}
      disabled={processing || isValidatingAppointment}
    />
  );
};
ApplePay.propTypes = {
  className: PropTypes.string,
  processing: PropTypes.bool,
  hasApplePay: PropTypes.bool,
  onClick: PropTypes.func,
  isValidatingAppointment: PropTypes.bool,
};
ApplePay.defaultProps = {
  className: '',
  processing: false,
  hasApplePay: false,
  onClick: nullFunc,
  isValidatingAppointment: false,
};

const mapStateToProps = state => ({
  hasApplePay: state.app.applePay,
  isValidatingAppointment: getIsValidatingAppointment(state),
});
export default connect(mapStateToProps)(ApplePay);



// WEBPACK FOOTER //
// ./src/app/components/ApplePay.jsx